import {
    REPORT_LIST_RESPONSE,
    UNAUTHENTICATED
} from "../../actions/action-types"
import { extractEntitiesFromData } from "./entity-reducer-utils"

export default (state = {}, action) => {
    const { type, data } = action
    switch (type) {
        case REPORT_LIST_RESPONSE:
            const cleanedData = data
                .map(reportOrGroup => {
                    if (reportOrGroup.grouped_by) {
                        return reportOrGroup.items
                    }
                    return reportOrGroup
                })
                .reduce((flatList, listOrItem) => {
                    if (Array.isArray(listOrItem)) {
                        return [...flatList, ...listOrItem]
                    } else {
                        return [...flatList, listOrItem]
                    }
                }, [])
            return extractEntitiesFromData(cleanedData, state)
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}
